import angular from 'angular';
import '../core.module';

export const ROUTE_PERMISSIONS = {
  'app.dashboard': 'report.read',
  'app.conversations': 'conversation.read',
  'app.contacts': 'contacts.access',
  'app.crm': 'deal.read',
  'app.sales': 'order.read',
  'app.sales.bookings': 'order.read',
  'app.sales.validation': 'voucher.redeem',
  'app.products': 'product.read',
  'app.products.editor': 'product.read',
  'app.products.settings': 'product.update',
  'app.support': 'support.access',
  'app.chatbots': 'bot.read',
  'app.chatbots.editor': 'flow.edit',
  'app.ai-agents': 'ai_agent.read',
  'app.ai-agents.editor': 'ai_agent.read',
  'app.payments': 'payment.read',
  'app.automation': 'automation.edit',
  'app.campaigns': 'campaign.edit',
  'app.templates': 'template.read',
  'app.quick-replies': 'quick_reply.manage',
  'app.teams': 'team.manage',
  'app.reminders': 'reminder.read',
  'app.calendar': 'calendar.use',
  'app.admin-members': 'user.update',
  'app.notifications': 'notification.read',
  'app.permissions': 'role.manage',
  'app.numbers': 'channel.configure',
  'app.integrations': 'integration.configure',
  'app.reports': 'report.read',
  'app.analytics': 'report.read',
  'app.settings': 'settings.manage',
  'app.audit': 'audit.read',
  'app.connectors': 'channel.configure',
  'app.connectors.create': 'channel.configure',
  'app.connectors.edit': 'channel.configure',
  'app.connectors.details': 'channel.configure',
  'app.connectors.logs': 'channel.configure'
};

export function routePermission(stateName) {
  return ROUTE_PERMISSIONS[stateName];
}

angular.module('app.core').constant('ROUTE_PERMISSIONS', ROUTE_PERMISSIONS);
